module.exports = __webpack_public_path__ + "static/media/samsungsharpsans-medium_1.fc6a6a7b.woff";